export const LockscreenTranslationsDictionary = {
    Lockscreen: "Lockscreen",
    Driving: "Driving",
    ScreenDisabled: "The screen is disabled while driving.",
    LowestLimit: "Lowest limit",
    Availability: "Availability",
    BreakRequiredIn: "Break required in",
    RestLeft: "Break required in",
    DrivingLeft: "Driving left",
    WorkdayLeft: "Workday left",
    CycleLeft: "Cycle left",
    TimeLeft: "{0} left",
    Hours: "h",
    Minutes: "{minutes}m",
    InViolation: "You are in violation. For more details, tap on \"HOS\" once you have stopped.",
    AdverseWeather: "Adverse Driving Conditions exemption is active for the rest of your shift.",
    CriticalDefects: "You are driving a vehicle that has major defects identified in its Asset Inspection. Please review the Asset Inspection and contact your supervisor.",
    ManualLocationNeeded: "There are duty status change logs needing manual location entry due to an error or malfunction.",
    ExemptionActive: "You are currently under the {0} exemption.",
    PersonalConveyance: "Personal conveyance",
    YardMove: "Yard move",
    OilWellWaitTime: "Oil well wait time",
    Status: "Status:"
} as const;

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in LockscreenTranslationsDictionary) {
        r.push(LockscreenTranslationsDictionary[prop]);
    }
    return r;
};

export const LockscreenTranslations = getTranslations();
